module.exports = __webpack_public_path__ + "84249704630be7523bb6dd487f3bbceb.mp4";